import { ReactComponent as RemoveFill } from 'assets/icons/icon-remove-fill.svg';

export default RemoveFill;
